export default __webpack_public_path__ + "static/media/note.e49250c5.svg";